import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { HTMLParser } from "@gik/ui-legacy/HTMLParser";
import { SvgIcon } from "@gik/ui-legacy/SvgIcon/SvgIcon";
import { Zoom } from "@gik/ui-legacy/Zoom";
import ArrowCircleRightIcon from "@heroicons/react/outline/ArrowCircleRightIcon";
import type React from "react";
import { useTranslation } from "react-i18next";
import { CompetitorsComparisonTable } from "../CompetitorsComparisonTable";
import { PreviewSection } from "../PreviewSection";
import { translationKeys } from "./i18n/en";

const blockName = "competitors-preview";

export default function CompetitorsPreviewComp(): React.ReactElement {
	const bem = bemBlock(blockName);
	const { t } = useTranslation();

	return (
		<PreviewSection
			className={bem()}
			boxLink="/competitors"
			boxContent={
				<>
					<span className={bem("title")}>
						{HTMLParser({ rawHtml: t(translationKeys.title) })}
					</span>
					<div className={bem("content")}>
						<main>
							<div className={bem("description")}>
								{HTMLParser({ rawHtml: t(translationKeys.description) })}
							</div>
						</main>
						<aside>
							<SvgIcon
								Icon={ArrowCircleRightIcon}
								className={bem("icon")}
								size="xl"
							/>
						</aside>
					</div>
				</>
			}
		>
			<Zoom level={0.7}>
				<CompetitorsComparisonTable
					hasStickyHeader={false}
					className={bem("table")}
				/>
			</Zoom>
		</PreviewSection>
	);
}

export const CompetitorsPreview = withComponentErrorBoundary(
	CompetitorsPreviewComp,
);
